import * as am4core from "@amcharts/amcharts4/core";
import * as am4plugins_annotation from "@amcharts/amcharts4/plugins/annotation";
import * as am4charts from "@amcharts/amcharts4/charts";

export const am4ChartMixinLegacy = {
    methods: {
        // Create Am4 Chart
        am4CreateChart(name, type) {
            return am4core.create(name, type)
        },

        // Setup Chart Configuration
        am4SetupChartConfiguration(chart, formatter, frequencyToReload) {
            if (this._am4ChartInvalid(chart)) {
                return
            }

            chart.svgContainer.autoResize = false
            chart.preloader.delay = 2000
            chart.preloader.disabled = true
            chart.dataSource.parser = new am4core.JSONParser();
            chart.dataSource.parser.options.dateFormat = "i"
            chart.dateFormatter = formatter
            chart.dataSource.parser.options.dateFormatter = formatter
            chart.dataSource.reloadFrequency = frequencyToReload;
            chart.dataSource.incremental = true;

            chart.cursor = new am4charts.XYCursor()
        },

        // Add in am4 chart plugins
        am4SetupChartPlugins(chart) {
            if (this._am4ChartInvalid(chart)) {
                return
            }

            chart.exporting.menu = new am4core.ExportMenu();
            chart.exporting.filePrefix = this.fileName
            chart.exporting.dateFormat = 'i'
            chart.exporting.menu.events.on('hit', event => {
                if (!_.isNil(event.branch) && !_.isNil(event.branch.type) && event.branch.type !== 'annotate') {
                    if (window.fathomLoaded) {
                        window.fathom.trackGoal('K8TLPFJF', 0)
                    }
                }
            })
            chart.plugins.push(new am4plugins_annotation.Annotation());
        },

        // Check if a chart is invalid
        _am4ChartInvalid(chart) {
            return !_.isNil(chart)
        },
    },
}